module.exports = __webpack_public_path__ + "fonts/LidlFontPro-Book.woff2";